/**
 *  Activities Carousel
 */
import 'owl.carousel';
import { safeParseJSON } from './safeParseJSON.js';

const newsCarousel = function () {
  const $carousel = $('.owl-carousel');

  if ($carousel.length === 0) return;


  // default options
  var $optionsDef = {
    items: 3,
    lazyLoad: true,
    navText: ["<span class='arrow left'></span>","<span class='arrow right'></span>"]
  };

  // get external options from html data attribute
  var $optionsStrExt = $carousel.attr('data-slider-options');
  var $optionsExt = safeParseJSON($optionsStrExt) || {}; //console.log($optionsExt);

  // merge options
  var $options = $.extend($optionsExt, $optionsDef); //console.log($options);

  // initiate owl
  $carousel.owlCarousel($options);

  /*
  $carousel.owlCarousel({
    items: 3,
    margin: 30,
    loop: true,
    dots: false,
    nav: true,
    lazyLoad: true,
    responsive: {
      0: { items: 1 },
      480: { items: 1 },
      840: { items: 3 },
    },
  });
  */

};

export { newsCarousel };
